import React from "react";
import { Box, Card, CardContent, CardHeader, CardMedia, Link, Typography } from "@mui/material";

import CategoryCourseSearch from "./CategoryCourseSearch";
import TMSAvatar from "../TMSAvatar";


function CategoryCard({ category }) {
    return (
        <Card className="card">
            {!!category.image && (
                <CardMedia
                    component="img"
                    height="250"
                    image={category.image}
                    alt={category.name}
                />
            )}
            <CardHeader
                disableTypography={true}
                avatar={<TMSAvatar type="category" backgroundColor={category?.colour} />}
                title={
                    <Typography component="h2" className="card-header-title">
                        {category.name}
                    </Typography>
                }
                subheader={
                    <Typography component="span" className="card-header-subtitle" >
                        {`${category.courses} courses`}
                    </Typography>
                }
            />

            {!!category.description && (
                <CardContent>
                    <Box className="card-content">
                        <Typography variant="h3">Description</Typography>
                        <Typography variant="body1">
                            {category.description}
                        </Typography>
                    </Box>
                </CardContent>
            )}

            {category.subcategories?.length > 0 && (
                <CardContent>
                    <Box className="card-content">
                        <Typography variant="h3">Categories</Typography>
                        {category.subcategories.map((data) => {
                            return (
                                <div key={data.id} style={{padding: "8px 32px 8px 0", display: "inline"}}>
                                    <Link href={"/tms/library/" + data.id}>
                                        {data.name}
                                    </Link>
                                </div>
                            );
                        })}
                    </Box>
                </CardContent>
            )}
            <CardContent>
                <Box className="card-content">
                    <CategoryCourseSearch categoryId={category.id} />
                </Box>
            </CardContent>
        </Card>
    );
}

export default CategoryCard;
